import { Collapse } from "bootstrap";

export default function menuCollapseHelper() {
  const menu = document.querySelector('.menu');

  if (!menu) return;

  const collapseItems = menu.querySelectorAll('.collapse');

  collapseItems.forEach(collapseItem => {
    collapseItem.addEventListener('show.bs.collapse', event => {
      document.addEventListener('click', outsideClickHandler.bind(collapseItem));
      document.addEventListener('keydown', closeOnEsc.bind(collapseItem));
    })

    collapseItem.addEventListener('hide.bs.collapse', event => {
      document.removeEventListener('click', outsideClickHandler.bind(collapseItem));
      document.removeEventListener('keydown', closeOnEsc.bind(collapseItem));
    })
  })

  function outsideClickHandler(e) {
    if (!e.target.closest('.collapse')) {
      const collapseAPI = Collapse.getInstance(this);
      collapseAPI.hide()
    }
  }

  function closeOnEsc(e) {
    if (e.key === 'Escape') {
      const collapseAPI = Collapse.getInstance(this);
      collapseAPI.hide()
    }
  }
}
